//one-card-activeallergies/card.tsx
//Import dependencies
import * as React from 'react';
import Table from "antd/lib/table";

import {
  Card
} from 'one-ui-card/src/card';

import {
  ActiveAllergiesCardProps
} from './props';

import {
  AllergiesModal
} from './model';

import {
  checkCardHasError,
  TabErrorMsg
} from 'one-card-notification'

/**
 *  card renders all Active allergies of patient related data
 * @param props component properties
 * @returns JSX code for Active Allergies
 */
export const ActiveAlleriesCard = <M extends AllergiesModal>(
  props: ActiveAllergiesCardProps<M>
) => {
  const {
    model,
    title,
  } = props;

  const {
    allergies,
  } = model || {};
  let allergiesCardUI ;
  //Table columns.

  const columns = [
    {
      title: "Allergy Name",
      dataIndex: "allergenName",
      key: "allergyName"
    },
    {
      title: "Allergy Description",
      dataIndex: "allergenDescription",
      key: "allergyDescription",
      ellipsis:true
    },
    {
      title: "Date Entered",
      dataIndex: "dateEntered",
      key: "dateEntered"
    },
    {
      title: "Date Noted",
      key: "dateNoted",
      dataIndex: "dateNoted"
    },
    {
      title: "Reactions",
      key: "reactions",
      dataIndex: "reactions"
    },
    {
      title: "Reaction Comments",
      key: "reactionComment",
      dataIndex: "reactionComment"
    },
    {
      title: "Severity",
      key: "severity",
      dataIndex: "severity"
    },
    {
      title: "Type",
      key: "type",
      dataIndex: "type"
    }
  ];
  // To Check for the Error from the API
  if (checkCardHasError("ActiveAllergies") && allergies.length === 0) {
    allergiesCardUI =
      <>
        <TabErrorMsg />
      </>
  }
  else {
    allergiesCardUI =
      <>
        <Table columns={columns} dataSource={allergies}
          size={'small'}
          pagination={{ defaultPageSize: 4, showSizeChanger: false }}
        />
      </>
  }


  return (
    <Card
      title={title}
      body={allergiesCardUI}
    />
  );
};
